export const hasJeansWidthLengthSizes = (sizes?: any[]) => {
  if (!sizes || !Array.isArray(sizes)) return false;

  return sizes.some((size) => {
    const sizeName = size.name || size.label || "";

    const matchX = sizeName.match(/(\d+)x(\d+)/i);
    return matchX;
  });
};
